import React from "react";
import { Link } from "gatsby";
import { Arrow } from "../svg/other";
import { BtnText } from "./QueTexts";

export function ContinueButton({ to }) {
  return (
    <Link className="continue-btn" to={to}>
      <BtnText>Continue</BtnText>
      <Arrow />
    </Link>
  );
}

export function BackButton({ to }) {
  return (
    <Link className="back-btn" to={to}>
      <Arrow />
      <BtnText>Previous</BtnText>
    </Link>
  );
}

export function BlankButton() {
  return (
    <Link className="blank-btn">
      <Arrow />
      <BtnText>Previous</BtnText>
    </Link>
  );
}
